const imageHost = process.env.IMAGE_HOST || '/static';
const urlIcons = `${imageHost}/icon`;
const urlLogo = `${imageHost}/logo`;
const urlCauseBadge = `${imageHost}/cause/badge/`;
const urlTheGrapefulClub = `${imageHost}/page-the-grapeful-club/`;
const urlWineclub = `${imageHost}/wineclub`;
const urlShimmer2018 = `${imageHost}/page-shimmer-2018/`;
const urlSubscription = `${imageHost}/subscription`;
const UrlSvg = `${imageHost}/svg`;

const hopecommerceUrl =
  process.env.NODE_ENV === 'production'
    ? 'https://onehopewine.com'
    : 'http://localhost:3000';
const app = 'marketplace';

const stripePublicKey =
  process.env.STRIPE_PUBLIC_KEY || 'pk_test_oeJAQu45vnqpLPtHiarLW5Rv';

const nodeEnv = process.env.NODE_ENV;

const yotpoRedemptionId = process.env.YOTPO_REDEMPTION_ID || '358510';

module.exports = {
  imageHost,
  urlCauseBadge,
  urlIcons,
  urlLogo,
  urlShimmer2018,
  urlSubscription,
  urlTheGrapefulClub,
  urlWineclub,
  hopecommerceUrl,
  app,
  stripePublicKey,
  UrlSvg,
  nodeEnv,
  yotpoRedemptionId,
};
